var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsAndAnalyticsV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5008 9.99969C17.9608 9.99969 18.3383 9.62552 18.2925 9.16802C18.1004 7.25483 17.2526 5.46694 15.8928 4.10746C14.533 2.74797 12.7449 1.90055 10.8317 1.70886C10.3733 1.66302 10 2.04052 10 2.50052V9.16719C10 9.3882 10.0878 9.60016 10.2441 9.75644C10.4004 9.91273 10.6123 10.0005 10.8333 10.0005L17.5008 9.99969Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6747 13.2427C17.1445 14.4964 16.3153 15.6012 15.2596 16.4605C14.2038 17.3197 12.9537 17.9072 11.6184 18.1717C10.2831 18.4362 8.90337 18.3695 7.59981 17.9775C6.29624 17.5856 5.10854 16.8803 4.14053 15.9233C3.17253 14.9662 2.4537 13.7867 2.04688 12.4877C1.64006 11.1887 1.55765 9.80978 1.80685 8.47157C2.05605 7.13336 2.62926 5.87656 3.47639 4.81107C4.32351 3.74557 5.41875 2.90381 6.66635 2.35938",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsAndAnalyticsV2);
export default __webpack_public_path__ + "static/media/reportsAndAnalyticsV2.1a836537bfc0a8dda54d156c2571c3b3.svg";
export { ForwardRef as ReactComponent };